var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-jumbotron",
        { attrs: { fluid: "" } },
        [
          _c("template", { slot: "header" }, [
            _vm._v("\n            Bulk Registration\n        ")
          ]),
          _c("br"),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "7" } },
                [
                  _c("b-form-file", {
                    attrs: {
                      state: Boolean(_vm.exlFile),
                      accept: ".xlsx, .xls, .xlsm",
                      placeholder: "Strictly For Excel File Only"
                    },
                    on: {
                      change: function($event) {
                        _vm.printFile($event.target)
                      }
                    },
                    model: {
                      value: _vm.exlFile,
                      callback: function($$v) {
                        _vm.exlFile = $$v
                      },
                      expression: "exlFile"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            [
              !!_vm.exlFile
                ? _c(
                    "b-col",
                    { attrs: { sm: "7" } },
                    [
                      _c(
                        "b-alert",
                        {
                          staticClass: "selected-file-box",
                          attrs: { variant: "primary", show: "" }
                        },
                        [
                          _c("strong", [_vm._v("Registration File:")]),
                          _c("p", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.exlFile && _vm.exlFile.name) +
                                "\n                    "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          !!_vm.exlFile
            ? _c("b-row", [
                _c(
                  "div",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "7" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "selected-file-box",
                            attrs: { variant: "outline-success" },
                            on: {
                              click: function($event) {
                                _vm.bulkyRegister()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Bulk Registration\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _c("br"),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "7" } },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "selected-file-box",
                      attrs: { variant: "primary", show: "" }
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          "# NOTE: After registred, please upload important document and wait for EHS for approval."
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("br"),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "7" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        block: "",
                        href: "/templatesDownload/bulkyRegister/",
                        variant: "outline-success"
                      }
                    },
                    [_c("i", [_vm._v("[CLICK HERE] to download a template")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      !!_vm.$store.state.management.bulkyRegUserList
        ? _c("b-table", {
            staticClass: "bulky-reg-info-table",
            attrs: {
              fields: _vm.bulkyRegTableFields,
              items: _vm.$store.state.management.bulkyRegUserList,
              hover: "",
              striped: "",
              bordered: "",
              small: ""
            },
            scopedSlots: _vm._u([
              {
                key: "workingProfile",
                fn: function(row) {
                  return _vm._l(row.item.workingProfile, function(item, index) {
                    return _c(
                      "p",
                      { staticClass: "bulky-reg-working-profile" },
                      [
                        !!item
                          ? _c("span", [
                              _vm._v(
                                _vm._s(index) +
                                  ": " +
                                  _vm._s(_vm._f("parseDate")(item))
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  })
                }
              },
              {
                key: "uploadFile",
                fn: function(row) {
                  return [
                    row.item.errors == "Successful"
                      ? _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-info" },
                            on: {
                              click: function($event) {
                                _vm.popUpUploadFileModal(
                                  row.item,
                                  $event.target
                                )
                              }
                            }
                          },
                          [_vm._v("Upload File(ONLY PDF)")]
                        )
                      : _c("b-button", { attrs: { disabled: "" } }, [
                          _vm._v("UploadFiles")
                        ]),
                    _vm._v("\n            |\n            "),
                    row.item.errors == "Successful"
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              target: "_blank",
                              to: {
                                path: "/dashboard/management/" + row.item.id
                              },
                              variant: "outline-info"
                            }
                          },
                          [_vm._v("Edit User")]
                        )
                      : _c("b-button", { attrs: { disabled: "" } }, [
                          _vm._v("Edit User")
                        ])
                  ]
                }
              },
              {
                key: "errorInfo",
                fn: function(row) {
                  return [
                    row.item.errors == "Successful"
                      ? _c(
                          "b-alert",
                          { attrs: { variant: "success", show: "" } },
                          [_vm._v(_vm._s(row.item.errors))]
                        )
                      : row.item.errors.hasOwnProperty("username") ||
                        row.item.errors.hasOwnProperty("nricFin")
                        ? _c(
                            "b-alert",
                            { attrs: { variant: "danger", show: "" } },
                            _vm._l(row.item.errors, function(item, index) {
                              return _c(
                                "p",
                                { staticClass: "bulky-reg-working-profile" },
                                [_vm._v("Duplicated :" + _vm._s(index))]
                              )
                            })
                          )
                        : _vm._e()
                  ]
                }
              }
            ])
          })
        : _vm._e(),
      _c(
        "b-modal",
        { attrs: { id: "modalUploadFile", size: "lg" } },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  !!_vm.modalInfo.content["fileList"] &&
                  _vm.modalInfo.content["fileList"].length > 0
                    ? _c(
                        "b-col",
                        _vm._l(_vm.modalInfo.content["fileList"], function(
                          item,
                          index
                        ) {
                          return _c("p", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(index) +
                                ": " +
                                _vm._s(item) +
                                "\n                    "
                            )
                          ])
                        })
                      )
                    : _c("b-col", [
                        _c("p", [
                          _vm._v(
                            "\n                        No files uploaded yet, applicant is not able to proceed to submit for approval\n                    "
                          )
                        ])
                      ])
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("UploadFilePanel", {
                        on: { uploadTrainingFiles: _vm.uploadTrainingFiles }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      !!_vm.$store.state.management.bulkyRegUserList
        ? _c("p", [_vm._v("This is bulky reg list place")])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba5f0c98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba5f0c98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/management/bulkyRegister.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-ba5f0c98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/management/bulkyRegister.vue
// module chunks = 0 5